module.exports = __webpack_public_path__ + "static/media/445B.6e464648.pdb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/445B.pdb
// module id = 1779
// module chunks = 1